<!--
  Иконка контактных данных: карточка контакта.
  Обычно используется в блоках отправителя, получателя и контактной информации.
-->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="2"
      :stroke="stroke"
      stroke-width="2"
    />
    <circle
      cx="9"
      cy="11"
      r="2"
      :stroke="stroke"
      stroke-width="2"
    />
    <path
      d="M6 17C6.5 15.5 7.5 14.5 9 14.5C10.5 14.5 11.5 15.5 12 17M15 10H18M15 14H18"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "ContactIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
